var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { useLucidSdk } from '#context';
import { plugFilespaceClientInternal } from './usePlugFilespaceClient.services';
export const usePlugFilespaceClient = () => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const plugFilespaceClient = useCallback(({ action, filespaceId, workspaceId, }) => plugFilespaceClientInternal({
        action,
        clientId: filespaceId,
        loginClient: () => lucidSdk
            .workspaceClient(workspaceId)
            .filespaceLogin(filespaceId),
        logoutClient: () => lucidSdk
            .workspaceClient(workspaceId)
            .filespaceLogout(filespaceId),
    }), [lucidSdk]);
    return { plugFilespaceClient };
};
_react_refresh_temp_1(usePlugFilespaceClient, "gfPX5dFPo1s8tXfBrF106ahwmTg=", false, () => [useLucidSdk]);
